import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetLoyaltyNotificationPreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetLoyaltyNotificationPreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setLoyaltyNotificationPreference = (
  request: SetLoyaltyNotificationPreferenceRequest,
  options?: CashRequestOptions
) =>
  post<SetLoyaltyNotificationPreferenceRequest, SetLoyaltyNotificationPreferenceResponse>(
    '/2.0/cash/set-loyalty-notification-preference',
    request,
    { ...options, rejectOnError: true }
  )
